import { render, staticRenderFns } from "./SvgPolygons.vue?vue&type=template&id=a20c2e6a&scoped=true&"
import script from "./SvgPolygons.vue?vue&type=script&lang=ts&"
export * from "./SvgPolygons.vue?vue&type=script&lang=ts&"
import style0 from "./SvgPolygons.vue?vue&type=style&index=0&id=a20c2e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20c2e6a",
  null
  
)

export default component.exports